import React from 'react';
import Headlines from './allHeading';
import './ServicesMain.css'

const Tiles = (props) => {
    const Arr = props.Arr;
    const listItems = Arr.map((it) =>{
        return <li className = 'tilesNavBtnLink mt-3 mb-1'> {it} </li>
    })

    return (
        <div className = 'tilesDev text-center' style = {{backgroundImage : `url(${props.myImage})`} }>
            <Headlines
            headline = {props.headline}
            />
            <div className="img-fluid"
            style = {{display : 'flex' , justifyContent : 'flex-end' , flexDirection : 'column' , height : '100%'
            }}>
            
            <ul className = 'mt-0 pt-0 mb-0 pb-0 tilesNavBtn mb-0 pb-0 '> {listItems}
            </ul>
            </div>
        </div>
    )
}

export default Tiles
